module.exports = __webpack_public_path__ + "static/triumph_day-9ef8ced8a7f825a5c45f191268932d2b.jpg";